import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Avatar from 'core/icons/Avatar';
import { getColor } from 'core/utils/Styles';
import { Frame } from './styles';

class GravatarPic extends PureComponent {
	state = {
		gravatarError: false,
	}

	colors = [
		getColor('fountainBlue'),
		getColor('mantis'),
		getColor('shakespeare'),
		getColor('lavender'),
		getColor('roman'),
	]

	pickColor = () => {
		const { colors } = this;
		const { customerId } = this.props;
		const colorsLength = colors.length;
		const selectedIndex = customerId % colorsLength;
		return colors[selectedIndex];
	}

	onGravatarError = () => {
		this.setState({ gravatarError: true });
	}

	getGravatarUrl = () => {
		const { email, size } = this.props;
		const url = `//gravatar.com/avatar/${email}.jpg?d=404&r=g&s=${size}`;
		return url;
	}

	render () {
		const { gravatarError } = this.state;
		const { getGravatarUrl, colors, pickColor } = this;
		const { iconSize, size } = this.props;
		const gravatarUrl = getGravatarUrl();
		const color = pickColor();
		return (
			<Frame gravatarError={gravatarError} size={size}>
				{gravatarError ? (
					<Avatar width={iconSize} height={iconSize} color={color} />
				) : (
					<img data-src={gravatarUrl} className="lazyload" onError={this.onGravatarError} />
				)}
			</Frame>
		);
	}

	static propTypes = {
		customerId: PropTypes.number.isRequired,
		email: PropTypes.string.isRequired,
		size: PropTypes.number,
		iconSize: PropTypes.number,
	}

	static defaultProps = {
		size: 198,
		iconSize: 180,
	}
}

export default GravatarPic;
